import React from 'react';
import LegalPage from './LegalPage';

const H = ({ children }) => (
  <h2 className="text-[#242326] text-xl md:text-2xl font-medium font-['Inter'] mt-10 mb-3 first:mt-0">
    {children}
  </h2>
);

const CookiePolicy = () => (
  <LegalPage title="Cookie Policy" lastUpdated="29 April 2026" testid="cookie-policy-page">
    <H>What are cookies?</H>
    <p>
      Cookies are small text files placed on your device by websites you visit. They allow the site to
      remember your actions and preferences (such as login, language, font size and other display
      preferences) over a period of time, so you don&rsquo;t have to keep re-entering them whenever you come
      back to the site or browse from one page to another.
    </p>

    <H>How we use cookies</H>
    <p>
      We use cookies and similar technologies on{' '}
      <a href="https://www.grouth.co" className="text-[#83BF42] underline">www.grouth.co</a> to:
    </p>
    <ul className="list-disc pl-6 space-y-2">
      <li>Make the site work as you&rsquo;d expect (essential cookies — these can&rsquo;t be switched off).</li>
      <li>Remember your settings and preferences during your visit.</li>
      <li>Understand how visitors use the site so we can improve it (analytics cookies).</li>
      <li>Measure the performance of our marketing campaigns when you arrive from an ad or referral.</li>
    </ul>

    <H>Categories of cookies we use</H>
    <ul className="list-disc pl-6 space-y-3">
      <li>
        <strong>Strictly necessary</strong> — required for the site to function. They enable core
        functionality such as page navigation, network access, and remembering your consent choices. Without
        them the site cannot run properly.
      </li>
      <li>
        <strong>Preferences</strong> — remember choices you make (such as your preferred language) so we can
        provide a more personalised experience.
      </li>
      <li>
        <strong>Analytics</strong> — help us understand how visitors interact with the site by collecting and
        reporting information anonymously (page views, referrers, time on page).
      </li>
      <li>
        <strong>Marketing</strong> — used by our advertising partners to deliver relevant advertising and
        measure campaign performance. These are only set when you have given consent.
      </li>
    </ul>

    <H>Managing your cookie preferences</H>
    <p>
      We use{' '}
      <a
        href="https://usercentrics.com"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#83BF42] underline"
      >
        Usercentrics
      </a>{' '}
      as our consent management platform. The first time you visit, a banner asks you to accept or manage
      your cookie choices. You can revisit your choices at any time by clicking the small fingerprint icon in
      the bottom-left of any page on this site, or by clearing cookies in your browser and reloading.
    </p>
    <p>
      You can also block or delete cookies via your browser settings. Most browsers allow you to refuse
      cookies entirely or to be alerted when a cookie is being set. Please note that if you block all
      cookies, parts of the site may not function correctly.
    </p>

    <H>Third-party cookies</H>
    <p>
      Some cookies are set by third parties whose services appear on our pages (for example, embedded
      content, analytics or marketing pixels). The use of these cookies is governed by the privacy practices
      of those third parties. We don&rsquo;t control the setting of these cookies, so we suggest reviewing
      the relevant third party&rsquo;s privacy policy.
    </p>

    <H>Changes to this policy</H>
    <p>
      We may update this Cookie Policy from time to time to reflect changes in technology, law, or our use
      of cookies. The date at the top of this page indicates when the policy was last updated.
    </p>

    <H>Contact</H>
    <p>
      Questions about how we use cookies? Email{' '}
      <a href="mailto:ademola@grouth.co" className="text-[#83BF42] underline">ademola@grouth.co</a>. For broader
      questions about your data, see our{' '}
      <a href="/privacy" className="text-[#83BF42] underline">Privacy Policy</a>.
    </p>
  </LegalPage>
);

export default CookiePolicy;
